import academyService from 'src/services/api/academyService';
import Swal from 'sweetalert2';

export const addLessonProgress = (studentData, courseId, lessonId, completed) => {
  if (!studentData || !courseId || !lessonId) return studentData;

  const courseProgress = studentData.courseProgress?.[courseId];

  const completedLessons = completed
    ? [...new Set([...(courseProgress?.completedLessons || []), lessonId])]
    : (courseProgress?.completedLessons || []).filter((id) => id !== lessonId);

  return {
    ...studentData,
    courseProgress: {
      ...(studentData.courseProgress || {}),
      [courseId]: {
        ...(courseProgress || {}),
        completedLessons,
        course_id: courseId,
        guest_id: studentData.id,
      },
    },
  };
};

export const sendUpdateLessonProgress = (newStudentProgress, courseId) => {
  if (!newStudentProgress || !courseId) return;

  const currentCourseProgress = newStudentProgress.courseProgress?.[courseId];
  if (!currentCourseProgress) return;

  academyService
    .addStudentProgress({
      course_id: courseId,
      guest_id: currentCourseProgress.guest_id,
      completedLessons: currentCourseProgress.completedLessons || [],
    })
    .then((response) => {
      console.log('response', response);
    })
    .catch((error) => {
      console.log('error', error);
      Swal.fire({
        title: 'Error',
        text: error?.response?.data?.message || 'Hay un error al enviar el progreso',
        icon: 'error',
      });
    });
};

export const getCourseProgress = (studentData, courseId) => {
  if (!studentData || !courseId) return null;
  return studentData.courseProgress?.[courseId] || null;
};

export const getEnrolledCourses = (studentData, courses) => {
  if (!studentData || !courses) return [];

  const enrolledCourses = Object.keys(studentData.courseProgress || {}).map((courseId) =>
    parseInt(courseId)
  );
  return enrolledCourses.map((courseId) => {
    const course = courses.find((c) => c.id === courseId);
    const progress = studentData.courseProgress?.[courseId];

    return {
      ...course,
      course: course?.AcademyLessons?.map((lesson) => ({
        ...lesson,
        completed: progress?.completedLessons?.includes(lesson.id) || false,
        locked: !(progress?.completedLessons?.includes(lesson.id) || false) && lesson.locked,
      })),
    };
  });
};
